import { render } from "./ClientSpaceReferralPlan.vue?vue&type=template&id=59ca3041&scoped=true"
import script from "./ClientSpaceReferralPlan.vue?vue&type=script&lang=js"
export * from "./ClientSpaceReferralPlan.vue?vue&type=script&lang=js"

import "./custom-clientSpace.scss?vue&type=style&index=0&id=59ca3041&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59ca3041"]])

export default __exports__